import { render, staticRenderFns } from "./configView.vue?vue&type=template&id=a88a64dc&scoped=true"
import script from "./configView.vue?vue&type=script&lang=js"
export * from "./configView.vue?vue&type=script&lang=js"
import style0 from "./configView.vue?vue&type=style&index=0&id=a88a64dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88a64dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a88a64dc')) {
      api.createRecord('a88a64dc', component.options)
    } else {
      api.reload('a88a64dc', component.options)
    }
    module.hot.accept("./configView.vue?vue&type=template&id=a88a64dc&scoped=true", function () {
      api.rerender('a88a64dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/baseInfo/hotelInit/configView.vue"
export default component.exports